import { render, staticRenderFns } from "./attrs-header.vue?vue&type=template&id=87889e8c&"
import script from "./attrs-header.vue?vue&type=script&lang=js&"
export * from "./attrs-header.vue?vue&type=script&lang=js&"
import style0 from "./attrs-header.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports